import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(m[1]);

    (async () => {
      try {
        const r = await api.post("/auth/emergent/session", { session_id: sessionId });
        // clear hash from URL
        window.history.replaceState(null, "", window.location.pathname);
        const user = await refresh();
        if (r.data?.linked_now) {
          toast.success("Account Google collegato al tuo account esistente");
        } else {
          toast.success(`Benvenuto ${user?.name || ""}`);
        }
        // First-time Google user without tenant → onboarding
        if (r.data?.needs_onboarding) {
          navigate("/onboarding", { replace: true });
          return;
        }
        navigate(user?.role === "agency_admin" ? "/admin" : "/app", { replace: true });
      } catch (err) {
        toast.error("Accesso Google fallito");
        navigate("/login", { replace: true });
      }
    })();
  }, [location, navigate, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[color:var(--sp-bg)]">
      <div className="text-center">
        <div className="inline-block w-10 h-10 border-2 border-[color:var(--sp-brand)] border-t-transparent rounded-full animate-spin" />
        <p className="mt-4 text-sm text-[color:var(--sp-text-secondary)]">Accesso in corso…</p>
      </div>
    </div>
  );
}
